import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Spinner } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { relationshipModel } from '~/models';
import { getInvoiceDateInfo } from '~/pages/AgreementMinisite/BillingHub/BillingHub.utils';
import { BIRelationshipScopeProvider } from '~/providers/BIRelationshipScopeProvider';
import { useInvoiceDraftDates } from '../../AdHocBillModal/hooks/useInvoiceDraftDates';
import { BillModalShell } from '../../components/BillModalShell/BillModalShell';
import { createEmptyChargeItem } from '../../utils/lineItem.utils';
import { BillClientModalContent } from '../BillClientModal';
import styles from '../BillClientModal.module.scss';
import { useBillingControlData } from '../hooks/useBillingControlData';
export const GetSmartBillClientModalTID = (parentTestId)=>getTestIds(parentTestId);
export function SmartBillClientModal(param) {
    let { relationshipId, dismissModal } = param;
    const { SmartBillClientModalTestIds } = useMemo(()=>GetSmartBillClientModalTID(), []);
    const { relationship, isLoading: isRelationshipLoading } = useRelationship(relationshipId, {
        refreshOnMount: true
    });
    const { billingControlData, isLoading: isControlDataLoading } = useBillingControlData(relationshipId, {
        refreshOnHookMount: true
    });
    const { invoiceDraftDates, isLoading: isDatesLoading } = useInvoiceDraftDates(relationshipId, {
        refreshOnHookMount: true
    });
    const defaultItem = useMemo(()=>createEmptyChargeItem(), []);
    const isLoading = isRelationshipLoading || isControlDataLoading || isDatesLoading;
    const hasAllData = relationship != null && billingControlData != null && invoiceDraftDates != null;
    if (isLoading || !hasAllData) {
        return /*#__PURE__*/ _jsx(BillModalShell, {
            title: "",
            onClose: dismissModal,
            children: /*#__PURE__*/ _jsx(Box, {
                className: styles.loadingWrapper,
                testId: SmartBillClientModalTestIds.LoadingSpinner(),
                children: /*#__PURE__*/ _jsx(Spinner, {
                    size: 48
                })
            })
        });
    }
    const selectedDate = invoiceDraftDates.dates().length > 0 ? invoiceDraftDates.dates()[0] : null;
    const resolvedProps = {
        relationshipId,
        dismissModal,
        defaultItem,
        controlData: billingControlData,
        totalCredits: billingControlData.totalCredits,
        manualServicesBilling: billingControlData.manualServices,
        earliestBillableDate: invoiceDraftDates.earliestBillableDate(),
        invoiceDateInfo: getInvoiceDateInfo(selectedDate, invoiceDraftDates)
    };
    return /*#__PURE__*/ _jsx(BIRelationshipScopeProvider, {
        relationshipScope: {
            id: relationshipId,
            isApproved: relationshipModel.isApproved(relationship)
        },
        children: /*#__PURE__*/ _jsx(BillClientModalContent, _object_spread({}, resolvedProps))
    });
}
